export default __webpack_public_path__ + "static/media/pt.0603403e.svg";